//계약서 변수 키 사전 — 서버 peetsunbaeserver/src/control/staffContract.ts 의 VAR_KEYS 와 반드시 동일하게 유지
//탬플릿 빈칸(fieldId) ↔ 우리 변수 연결 드롭다운의 선택지

export const NONE_KEY = "__none";   //Joy Select 는 null 값을 고를 수 없어서 "(연결 안 함)" 센티널

export interface ContractVarKey {
    value: string;
    label: string;
    group: "common" | "branch" | "part" | "dynamic";
}

export const CONTRACT_VAR_KEYS: ContractVarKey[] = [
    { value: "common.businessName", label: "공통 · 사업체명", group: "common" },
    { value: "common.hourlyWage", label: "공통 · 시급", group: "common" },
    { value: "common.fullAttendanceAllowance", label: "공통 · 만근수당", group: "common" },
    { value: "common.baseHourlyWage", label: "공통 · 기본시급", group: "common" },
    { value: "branch.representative", label: "지점 · 대표자", group: "branch" },
    { value: "branch.address", label: "지점 · 소재지", group: "branch" },
    { value: "branch.corporation", label: "지점 · 법인", group: "branch" },
    { value: "part.startTime", label: "파트 · 시업시간", group: "part" },
    { value: "part.endTime", label: "파트 · 종업시간", group: "part" },
    { value: "part.breakTime", label: "파트 · 휴게시간", group: "part" },
    { value: "part.dailyHours", label: "파트 · 일근무시간", group: "part" },
    { value: "part.weeklyHours", label: "파트 · 소정근로시간", group: "part" },
    { value: "part.stayHours", label: "파트 · 체류시간", group: "part" },
    { value: "part.remainingHours", label: "파트 · 나머지시간", group: "part" },
    { value: "part.workDays", label: "파트 · 근무요일", group: "part" },
    { value: "dynamic.period", label: "자동 · 계약기간", group: "dynamic" },
    { value: "dynamic.contractDate", label: "자동 · 계약일자", group: "dynamic" },
    { value: "dynamic.signDate", label: "자동 · 서명일자", group: "dynamic" },
    { value: "dynamic.staffName", label: "자동 · 직원 이름", group: "dynamic" },
];

export interface PartVars {
    startTime: string;
    endTime: string;
    breakTime: string;
    dailyHours: string;
    weeklyHours: string;
    stayHours: string;
    remainingHours: string;
    workDays: string;
}

//파트 변수 8개 — 다이얼로그 입력칸과 테이블 컬럼 순서가 이걸 따름
export const PART_VAR_FIELDS: { key: keyof PartVars; label: string; short: string; width: number }[] = [
    { key: "startTime", label: "시업시간", short: "시업", width: 60 },
    { key: "endTime", label: "종업시간", short: "종업", width: 60 },
    { key: "breakTime", label: "휴게시간", short: "휴게", width: 100 },
    { key: "dailyHours", label: "일근무시간", short: "일근무", width: 80 },
    { key: "weeklyHours", label: "소정근로시간", short: "소정근로", width: 95 },
    { key: "stayHours", label: "체류시간", short: "체류시간", width: 150 },
    { key: "remainingHours", label: "나머지시간", short: "나머지", width: 80 },
    { key: "workDays", label: "근무요일", short: "요일", width: 60 },
];

export const emptyPartVars = (): PartVars => ({
    startTime: "", endTime: "", breakTime: "", dailyHours: "", weeklyHours: "", stayHours: "", remainingHours: "", workDays: ""
});

export type MappingState = "complete" | "unmapped" | "noTemplate";

export interface MappingStatus {
    state: MappingState;
    unmappedCount: number;
    fieldCount: number;
}

export interface TemplateField {
    fieldId: string;
    fieldName: string;
    fieldType: string;
    required: boolean;
}

//다이얼로그 안에서 실시간 계산용 (서명 필드 제외). 테이블은 서버가 내려준 part.mappingStatus 를 그대로 씀
export const computeMappingStatus = (templateId: string | null, fields: TemplateField[], mapping: { [fieldId: string]: string | null }): MappingStatus => {
    if (!templateId) {
        return { state: "noTemplate", unmappedCount: 0, fieldCount: 0 };
    }
    const targets = fields.filter((f) => f.fieldType !== "signature");
    const unmappedCount = targets.filter((f) => !mapping[f.fieldId]).length;
    return { state: unmappedCount > 0 ? "unmapped" : "complete", unmappedCount, fieldCount: targets.length };
};

export const varKeyLabel = (key: string | null): string => {
    if (!key) return "(연결 안 함)";
    const found = CONTRACT_VAR_KEYS.find((k) => k.value === key);
    return found ? found.label : key;
};
